import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Menu, X, ArrowUpRight, UserRound } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../account/AuthContext';
import { Button } from '../ui/button';
import { content, Logo } from './Shared';

export const Navbar = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('home');
  useEffect(() => {
    const sections = content.navigation.map(item => document.getElementById(item.id)).filter(Boolean);
    const scroll = () => {
      setScrolled(window.scrollY > 20);
      const marker = (document.querySelector('.site-header')?.offsetHeight || 0) + 100;
      const current = [...sections].reverse().find(section => section.getBoundingClientRect().top <= marker);
      setActive(current?.id || 'home');
    };
    window.addEventListener('scroll', scroll, { passive: true });
    scroll();
    const key = e => { if (e.key === 'Escape') { setOpen(false); document.getElementById('mobile-menu-button')?.focus(); } };
    document.addEventListener('keydown', key);
    return () => { window.removeEventListener('scroll', scroll); document.removeEventListener('keydown', key); };
  }, []);
  return <header className={`site-header ${scrolled ? 'scrolled' : ''}`} data-testid="site-header">
    <div className="nav-inner wrap">
      <a href="#home" className="logo-link" aria-label="QualiNova home" data-testid="navbar-logo-link" onClick={() => setOpen(false)}><Logo id="navbar-logo"/></a>
      <nav className="desktop-nav" aria-label="Main navigation">{content.navigation.map(item => <a key={item.id} href={`#${item.id}`} className={active === item.id ? 'active' : ''} aria-current={active === item.id ? 'location' : undefined} data-testid={`nav-${item.id}`}>{item.label}</a>)}</nav>
      <Button asChild className="nav-cta"><a href="#contact" data-testid="nav-get-in-touch">Get in Touch <ArrowUpRight size={16}/></a></Button>
      <Link to={user ? '/dashboard' : '/login'} className="navbar-account" data-testid="navbar-account-link" aria-label={user ? 'Open your account' : 'Sign in'} title={user ? 'Your account' : 'Sign in'}><UserRound size={19}/></Link>
      <Button id="mobile-menu-button" className="mobile-menu-button" variant="ghost" size="icon" data-testid="mobile-menu-toggle" aria-expanded={open} aria-controls="mobile-navigation" aria-label={open ? 'Close navigation' : 'Open navigation'} onClick={() => setOpen(!open)}>{open ? <X/> : <Menu/>}</Button>
    </div>
    <AnimatePresence>{open && <motion.nav id="mobile-navigation" className="mobile-navigation" aria-label="Mobile navigation" initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}>
      {content.navigation.map((item, i) => <a href={`#${item.id}`} key={item.id} data-testid={`mobile-nav-${item.id}`} onClick={() => setOpen(false)}><span className="nav-number">0{i + 1}</span>{item.label}<ArrowUpRight size={18}/></a>)}
    </motion.nav>}</AnimatePresence>
  </header>;
};